import React from "react";
import { Box } from "@mui/material";
import GlobalSearchIcon from "assets/icons/GlobalSearch";

const EmptySearch = () => {
  return (
    <Box>
      <GlobalSearchIcon size="274px" />
      <Box
        sx={{
          fontSize: "18px",
          textTransform: "uppercase",
          color: "common.caGrey.main",
          letterSpacing: "0.75px",
          paddingTop: "33px",
        }}
        data-test-id="gs-zero-state-message"
      >
        ENTER KEYWORD IN THE SEARCH BAR TO CONTINUE
      </Box>
    </Box>
  );
};

export default EmptySearch;
